/**
 * ENFAMI Mobile — Voir plus (3 lignes), header compact helpers
 */
(function () {
  'use strict';

  var MQ = window.matchMedia('(max-width: 749px)');

  function moreLabel(expanded) {
    var lang = (document.documentElement.lang || '').toLowerCase();
    var fr = lang.indexOf('fr') === 0;
    if (expanded) return fr ? 'Voir moins' : 'Show less';
    return fr ? 'Voir plus' : 'See more';
  }

  function needsMore(container, hiddenSelector) {
    if (!container) return false;
    var hidden = container.querySelectorAll(hiddenSelector);
    return hidden.length > 0;
  }

  function ensureMoreBtn(sec, kind) {
    if (!MQ.matches) {
      var existing = sec.querySelector('.ef-mobile-more');
      if (existing) existing.remove();
      sec.classList.remove('is-mobile-expanded');
      return;
    }

    if (sec.querySelector('.ef-mobile-more')) return;

    var hasHidden = false;
    if (kind === 'products') {
      hasHidden = sec.querySelectorAll('.nm-prod-grid > .nm-prod-grid__item:nth-child(n+7)').length > 0;
      /* nth-child always matches in DOM even if CSS hides — count items */
      var items = sec.querySelectorAll('.nm-prod-grid > .nm-prod-grid__item');
      hasHidden = items.length > 6;
    } else {
      return;
    }

    if (!hasHidden) return;

    var wrap = document.createElement('div');
    wrap.className = 'ef-mobile-more';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ef-mobile-more__btn';
    btn.setAttribute('data-mode', 'expand');
    btn.textContent = moreLabel(false);
    btn.addEventListener('click', function () {
      var open = sec.classList.toggle('is-mobile-expanded');
      btn.textContent = moreLabel(open);
      btn.setAttribute('data-mode', open ? 'collapse' : 'expand');
    });
    wrap.appendChild(btn);

    var grid = sec.querySelector('.nm-prod-grid, .nm-team-carousel');
    if (grid && grid.parentNode) {
      grid.parentNode.insertBefore(wrap, grid.nextSibling);
    } else {
      sec.appendChild(wrap);
    }
  }

  function initSections() {
    document.querySelectorAll('.nm-sec').forEach(function (sec) {
      if (sec.querySelector('.nm-prod-grid')) ensureMoreBtn(sec, 'products');
    });
  }

  function boot() {
    initSections();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  if (MQ.addEventListener) {
    MQ.addEventListener('change', boot);
  } else if (MQ.addListener) {
    MQ.addListener(boot);
  }

  document.addEventListener('shopify:section:load', boot);
})();
